export default __webpack_public_path__ + "static/media/goopter-pudubot-intelligent-efficient.42cb5cfe.png";